export const INITIAL_RENDER = 'gbds-initialRender'
export const HEIGHT_RENDER = 'gbds-heightRender'
export const NAV_STICKY = 'gbds-navSticky'
export const NAV_UNSTICKY = 'gbds-navUnSticky'
export const MYACCOUNT_LOADED = 'gbds-myaccountLoaded'
